<template>
  <v-container>
    <v-row justify="center">
      <v-flex xs12>
        <v-progress-circular/>
        {{ message }}
      </v-flex>
      <v-flex xs12>
        Account {{ user? user.name : '' }} {{ user ? user.surname : '' }}
      </v-flex>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Processing',
  props: {
    redirect: {
      type: String,
      default: '/dashboard',
    },
  },
  data() {
    return {
      message: 'Processing',
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  watch: {
    user(v) {
      if (v) {
        if (v && v.first_name) {
          this.$router.push(this.$props.redirect || '/dashboard')
        } else {
          this.$router.push('/complete_signup')
        }
      }
    }
  },
  methods: {
  },
  created() {
    if (!this.$store.getters.user) {
      this.message = 'Processing'
    } else { this.message = 'Done' }

    this.message = 'Redirecting'
  },
}
</script>

<style scoped>

</style>
